import React, { useEffect, useState, useCallback } from 'react';
import EmployeeForm from '../../form/subscription/EmployeeForm';
import { getUser } from '../../api';
import useApplicationSession from '../../session/UserSession';

const Employee = () => {
    const [userdata, setUserdata] = useState(null);
    const token = useApplicationSession();
    const getUserInfo = useCallback(() => {
        if (token) {
            getUser({ token })
                .then((response) => {
                    const { employee } = response.data;
                    setUserdata(employee);
                })
                .catch((error) => {});
        }
    }, [token]);

    useEffect(() => {
        getUserInfo();
    }, [getUserInfo]);

    return (
        <div test_id="subscription-employee" className="subscriptionContentContainer">
            <EmployeeForm value={userdata} />
        </div>
    );
};

export default Employee;
